// @ts-nocheck

import { createSelector } from 'reselect';

import { KLRound3StepIdsByOrder } from '../../constants/order';
import { KLCollectibleStatuses } from '../../types/collectible';
import { selectKLOrientationPaginationIndex } from '../misc';
import { selectKLUserOrientation } from '../user';

const emptyObj = {};

const getPaginationIndexFromProps = (_, { paginationIndex }) => paginationIndex ?? null;
const getStepIdFromProps = (_, { stepId }) => stepId ?? null;

const selectOrientationState = createSelector(
  [selectKLUserOrientation, selectKLOrientationPaginationIndex],
  (orientationState, paginationIndex) => orientationState?.[paginationIndex] ?? emptyObj,
);

const selectOrientationFakeState = createSelector([selectOrientationState], (orientationState) => {
  const fakeOrientationStatusState = {};
  let forceDisabling = false;

  for (let i = 0; i < KLRound3StepIdsByOrder.length; i++) {
    const stepId = KLRound3StepIdsByOrder[i];

    fakeOrientationStatusState[stepId] = {
      ...(orientationState[stepId] ?? {}),
      status: {
        value: orientationState[stepId]?.status,
        forceDisabling,
      },
    };

    if (
      (!forceDisabling && orientationState[stepId]?.status === KLCollectibleStatuses.OPEN) ||
      orientationState[stepId]?.status === KLCollectibleStatuses.PENDING ||
      orientationState[stepId]?.status === KLCollectibleStatuses.LOST
    ) {
      forceDisabling = true;
    }
  }

  return fakeOrientationStatusState;
});

const selectOrientationStepStatus = createSelector(
  [getStepIdFromProps, selectOrientationFakeState],
  (stepId, orientationState) => orientationState[stepId]?.status ?? null,
);

const selectKLOrientationStepProps = createSelector(
  [selectOrientationStepStatus, getPaginationIndexFromProps, getStepIdFromProps],
  (status, paginationIndex, stepId) => ({
    status,
    paginationIndex,
    stepId,
  }),
);

export default selectKLOrientationStepProps;
